import { Controller } from "@hotwired/stimulus"

// Auto-submits the Dials params bar when a control changes, so the selects
// read as controls rather than as a form you have to remember to submit.
//
// It submits the FORM (a GET), which means every state of the dashboard is a
// real URL with history — the back button steps through the views you looked
// at, and the address bar is always shareable. Empty params are stripped first
// so the URL stays legible instead of accumulating `breakdown=&interval=`.
export default class extends Controller {
  submit() {
    this.element
      .querySelectorAll("select, input")
      .forEach((field) => {
        if (field.value === "" && field.name !== "") field.disabled = true
      })
    this.element.requestSubmit()
  }
}
